import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookSquare, faInstagram } from '@fortawesome/free-brands-svg-icons';
import Navbar from '../Navbar';
import logo from '../../images/Limitless-BNG_WordmarkLogo.png';
import './index.scss';

const HOURS = [
  ['Monday',    '11:30AM - 2AM'],
  ['Tuesday',   '11:30AM - 2AM'],
  ['Wednesday', '11:30AM - 2AM'],
  ['Thursday',  '11:30AM - 2AM'],
  ['Friday',    '11:30AM - 2AM'],
  ['Saturday',  '11:30AM - 2AM'],
  ['Sunday',    '11:30AM - 12AM'],
];

const ReservationThankYou = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="reservation-thank-you">
      <Navbar />

      <div className="thank-you-body">
        <h1 className="thank-you-message">
          Thank You For Your Reservation<br />at Limitless Bar &amp; Grill!
        </h1>

        <Link to="/landing2" className="home-btn">
          Go Back To Homepage
        </Link>
      </div>

      {/* Footer */}
      <footer className="footer" id="contact">
        <div className="footer-top">
          <div className="footer-col">
            <h3>Contact Us</h3>
            <p>1450 Centre St., Unit 3</p>
            <p>L4J 3N1, Thornhill, ON</p>
            <br />
            <p>T: (905) 597-5252</p>
            <p>E: limitlessbarandgrill@gmail.com</p>
          </div>
          <div className="footer-col">
            <h3>Store Hours</h3>
            {HOURS.map(([day, hrs]) => (
              <div className="hours-row" key={day}>
                <span>{day}</span>
                <span>{hrs}</span>
              </div>
            ))}
          </div>
          <div className="footer-col footer-logo-col">
            <img src={logo} alt="Limitless Bar & Grill" className="footer-logo" />
          </div>
        </div>
        <div className="footer-social">
          <a href="https://www.facebook.com/limitlessbng" target="_blank" rel="noreferrer">
            <FontAwesomeIcon icon={faFacebookSquare} size="2x" />
          </a>
          <a href="https://www.instagram.com/limitlessbng" target="_blank" rel="noreferrer">
            <FontAwesomeIcon icon={faInstagram} size="2x" />
          </a>
        </div>
      </footer>
    </div>
  );
};

export default ReservationThankYou;
